<template>
  <div id="data-list-list-view" class="data-list-container">

    <!-- <vs-table :noDataText="$t('No_data_Available')" ref="table" :data="sexes"> -->

    <vx-card title="Éffectifs par niveaux">
      <div slot="no-body" class="mt-4" v-if="student_dashboard && student_dashboard.statistic_niveaux && student_dashboard.statistic_niveaux.length">
        <vs-table :data="student_dashboard.statistic_niveaux" class="table-dark-inverted">
          <template slot="thead">
            <vs-th> Niveau </vs-th>
            <vs-th> Nouveau (G) </vs-th>
            <vs-th> Ancien (G) </vs-th>
            <vs-th> Total (G) </vs-th>
            <vs-th> Nouveau (F) </vs-th>
            <vs-th> Ancien (F) </vs-th>
            <vs-th> Total (F) </vs-th>
            <vs-th> Nombre d'élève </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
              <vs-td>
                <span> <h3> {{tr.libelle}} </h3> </span>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status mr-3"> <h3 class="m-1" style="color: white"> {{tr.garcon.nouveau.nombre}} </h3> </vs-chip>

                <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr.garcon.nouveau.pourcentage}} %  </h3> </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr.garcon.ancien.nombre}} </h3> </vs-chip>

                <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr.garcon.ancien.pourcentage}} %  </h3> </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr.garcon.nombre}} </h3> </vs-chip>

                <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr.garcon.pourcentage}} %  </h3> </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr.file.nouveau.nombre}} </h3> </vs-chip>

                <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr.file.nouveau.pourcentage}} %  </h3> </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr.file.ancien.nombre}} </h3> </vs-chip>

                <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr.file.ancien.pourcentage}} %  </h3> </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr.file.nombre}} </h3> </vs-chip>

                <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr.file.pourcentage}} %  </h3> </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr.nombre}} </h3> </vs-chip>

                <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr.pourcentage}} %  </h3> </vs-chip>
              </vs-td>


              <template slot="expand">
                <vx-card color="black" style="background-color: black">
                  <div slot="no-body" class="p-1">
                    <h3 style="color: white"> Éffectifs par classe </h3>
                    <vs-table :data="tr.classes" style="background-color: black">
                      <template slot="thead">
                        <vs-th> Classe </vs-th>
                        <vs-th> Nouveau (G) </vs-th>
                        <vs-th> Ancien (G) </vs-th>
                        <vs-th> Total (G) </vs-th>
                        <vs-th> Nouveau (F) </vs-th>
                        <vs-th> Ancien (F) </vs-th>
                        <vs-th> Total (F) </vs-th>
                        <vs-th> Nombre d'élève </vs-th>
                      </template>

                      <template slot-scope="{data}">
                        <vs-tr :key="indextr1" v-for="(tr1, indextr1) in data" class="border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">

                          <vs-td>
                            <span> {{tr1.libelle}} </span>
                          </vs-td>

                          <vs-td>
                            <vs-chip color="primary" class="product-order-status mr-3"> <h3 class="m-1" style="color: white"> {{tr1.garcon.nouveau.nombre}} </h3> </vs-chip>

                            <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr1.garcon.nouveau.pourcentage}} %  </h3> </vs-chip>
                          </vs-td>

                          <vs-td>
                            <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr1.garcon.ancien.nombre}} </h3> </vs-chip>

                            <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr1.garcon.ancien.pourcentage}} %  </h3> </vs-chip>
                          </vs-td>

                          <vs-td>
                            <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr1.garcon.nombre}} </h3> </vs-chip>

                            <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr1.garcon.pourcentage}} %  </h3> </vs-chip>
                          </vs-td>

                          <vs-td>
                            <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr1.file.nouveau.nombre}} </h3> </vs-chip>

                            <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr1.file.nouveau.pourcentage}} %  </h3> </vs-chip>
                          </vs-td>

                          <vs-td>
                            <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr1.file.ancien.nombre}} </h3> </vs-chip>

                            <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr1.file.ancien.pourcentage}} %  </h3> </vs-chip>
                          </vs-td>

                          <vs-td>
                            <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr1.file.nombre}} </h3> </vs-chip>

                            <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr1.file.pourcentage}} %  </h3> </vs-chip>
                          </vs-td>

                          <vs-td>
                            <vs-chip color="#7961F9" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr1.nombre}} </h3> </vs-chip>

                            <vs-chip color="primary" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr1.pourcentage}} %  </h3> </vs-chip>
                          </vs-td>


                          <template slot="expand">
                            <vx-card color="black" style="background-color: black">
                              <div slot="no-body" class="p-1">
                                <h3 style="color: white"> Éffectifs par salle </h3>
                                <vs-table :data="tr1.salles" style="background-color: black">
                                  <template slot="thead">
                                    <vs-th> Salle </vs-th>
                                    <vs-th> Nouveau (G) </vs-th>
                                    <vs-th> Ancien (G) </vs-th>
                                    <vs-th> Total (G) </vs-th>
                                    <vs-th> Nouveau (F) </vs-th>
                                    <vs-th> Ancien (F) </vs-th>
                                    <vs-th> Total (F) </vs-th>
                                    <vs-th> Nombre d'élève </vs-th>
                                  </template>

                                  <template slot-scope="{data}">
                                    <vs-tr :key="indextr2" v-for="(tr2, indextr2) in data" class="border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">

                                      <vs-td>
                                        <span> {{tr2.libelle}} </span>
                                      </vs-td>

                                      <vs-td>
                                        <vs-chip color="primary" class="product-order-status mr-3"> <h3 class="m-1" style="color: white"> {{tr2.garcon.nouveau.nombre}} </h3> </vs-chip>

                                        <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr2.garcon.nouveau.pourcentage}} %  </h3> </vs-chip>
                                      </vs-td>

                                      <vs-td>
                                        <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr2.garcon.ancien.nombre}} </h3> </vs-chip>

                                        <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr2.garcon.ancien.pourcentage}} %  </h3> </vs-chip>
                                      </vs-td>

                                      <vs-td>
                                        <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr2.garcon.nombre}} </h3> </vs-chip>

                                        <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr2.garcon.pourcentage}} %  </h3> </vs-chip>
                                      </vs-td>

                                      <vs-td>
                                        <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr2.file.nouveau.nombre}} </h3> </vs-chip>

                                        <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr2.file.nouveau.pourcentage}} %  </h3> </vs-chip>
                                      </vs-td>

                                      <vs-td>
                                        <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr2.file.ancien.nombre}} </h3> </vs-chip>

                                        <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr2.file.ancien.pourcentage}} %  </h3> </vs-chip>
                                      </vs-td>

                                      <vs-td>
                                        <vs-chip color="primary" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr2.file.nombre}} </h3> </vs-chip>

                                        <vs-chip color="#7961F9" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr2.file.pourcentage}} %  </h3> </vs-chip>
                                      </vs-td>

                                      <vs-td>
                                        <vs-chip color="#7961F9" class="product-order-status mr-3"><h3 class="m-1" style="color: white"> {{tr2.nombre}} </h3> </vs-chip>

                                        <vs-chip color="primary" class="product-order-status"><h3 class="m-1" style="color: white"> {{tr2.pourcentage}} %  </h3> </vs-chip>
                                      </vs-td>

                                    </vs-tr>
                                  </template>
                                </vs-table>
                              </div>
                            </vx-card>
                          </template>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </vx-card>
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </div>

    </vx-card>

  </div>
</template>

<script>
export default {
  props: {
    student_dashboard: {
      type: Object,
      default: () => {}
    }
  }
}
</script>